export const BASE_URL = "https://server.healvick.com/api/";
// export const BASE_URL = "http://localhost:8000/api/";
